module.exports = __webpack_public_path__ + "static/media/Facebook.4fbf50b2.svg";